<template>
  <g>
    <g clip-path="url(#clip0)">
      <path
        d="M10.8666 18.6375C10.6702 18.6375 10.4738 18.562 10.3302 18.4184C10.1791 18.2673 10.096 18.0558 10.1111 17.8367L10.2773 15.0867C10.2925 14.8978 10.368 14.724 10.4964 14.5956L18.7012 6.38329C18.9883 6.0962 19.4869 6.0962 19.7664 6.38329L22.3578 8.97466C22.6525 9.2693 22.6525 9.74527 22.3578 10.0399L14.1531 18.2522C14.0246 18.3806 13.8509 18.4638 13.662 18.4713L10.912 18.63C10.8969 18.6375 10.8817 18.6375 10.8666 18.6375ZM11.7657 15.4569L11.6675 17.0736L13.2842 16.9754L20.7561 9.50351L19.2376 7.98495L11.7657 15.4569Z"
        :fill="iconColor"
      />
      <path
        d="M20.3727 11.0895C20.2744 11.0895 20.1762 11.0517 20.1082 10.9762L17.7813 8.64924C17.6302 8.49814 17.6302 8.26394 17.7813 8.11284C17.9324 7.96174 18.1666 7.96174 18.3177 8.11284L20.6446 10.4398C20.7957 10.5909 20.7957 10.8251 20.6446 10.9762C20.5615 11.0517 20.4709 11.0895 20.3727 11.0895Z"
        :fill="iconColor"
      />
      <path
        d="M11.2983 15.9531C11.2455 15.9531 11.1926 15.9531 11.1397 15.9607C11.0868 15.9682 11.0415 15.9833 10.9961 15.9909L10.8828 17.8948L12.7111 17.7814C12.7262 17.7134 12.7489 17.6454 12.7565 17.5699C12.8396 16.6406 12.1974 15.9531 11.2983 15.9531Z"
        :fill="iconColor"
      />
      <path
        d="M15.2542 21.54H4.72254C3.77061 21.54 3 20.7694 3 19.8175V5.68958C3 5.27406 3.33998 4.93408 3.7555 4.93408C4.17103 4.93408 4.511 5.27406 4.511 5.68958V19.825C4.511 19.9459 4.60166 20.0366 4.72254 20.0366H15.2542C15.3676 20.0366 15.4658 19.9459 15.4658 19.825V15.3676C15.4658 14.952 15.8057 14.6121 16.2213 14.6121C16.6368 14.6121 16.9768 14.952 16.9768 15.3676V19.825C16.9768 20.7694 16.2062 21.54 15.2542 21.54Z"
        :fill="iconColor"
      />
      <path
        d="M16.2225 10.6439C15.807 10.6439 15.467 10.304 15.467 9.88843V7.87879C15.467 7.76547 15.3764 7.66725 15.2555 7.66725C14.84 7.66725 14.5 7.32728 14.5 6.91175C14.5 6.49623 14.84 6.15625 15.2555 6.15625C16.2074 6.15625 16.978 6.92686 16.978 7.87879V9.88087C16.978 10.304 16.6381 10.6439 16.2225 10.6439Z"
        :fill="iconColor"
      />
      <path
        d="M15.1107 7.669H5.3345C4.05015 7.669 3 6.62641 3 5.3345C3 4.05015 4.05015 3 5.3345 3H16.2213C16.6368 3 16.9768 3.33998 16.9768 3.7555C16.9768 4.17103 16.6368 4.511 16.2213 4.511H5.3345C4.8812 4.511 4.511 4.8812 4.511 5.3345C4.511 5.7878 4.8812 6.15799 5.3345 6.15799H15.1107C15.5262 6.15799 15.8662 6.49797 15.8662 6.9135C15.8662 7.32902 15.5262 7.669 15.1107 7.669Z"
        :fill="iconColor"
      />
      <path
        d="M11.1223 10.4586H6.49103C6.27949 10.4586 6.11328 10.2924 6.11328 10.0809C6.11328 9.86934 6.27949 9.70312 6.49103 9.70312H11.1147C11.3262 9.70312 11.4924 9.86934 11.4924 10.0809C11.5 10.2849 11.3338 10.4586 11.1223 10.4586Z"
        :fill="iconColor"
      />
      <path
        d="M11.1223 12.5328H6.49103C6.27949 12.5328 6.11328 12.3666 6.11328 12.1551C6.11328 11.9436 6.27949 11.7773 6.49103 11.7773H11.1147C11.3262 11.7773 11.4924 11.9436 11.4924 12.1551C11.5 12.3591 11.3338 12.5328 11.1223 12.5328Z"
        :fill="iconColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect x="3" y="3" width="19.5826" height="18.54" fill="white" />
      </clipPath>
    </defs>
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#616161"
    }
  }
};
</script>
